<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M34 9a21 21 0 00-15.85 34.73l-8.71 8.71a1.49 1.49 0 000 2.12 1.5 1.5 0 002.12 0l8.71-8.71A21 21 0 1034 9zm0 39a18 18 0 1118-18 18 18 0 01-18 18z"/></svg>